/**
 * Maps the current app host to the corresponding equipment iframe zone.
 *
 * Legacy `app[-env].twenty20solutions.com` and new `remotevision[-env].epicio.com`
 * both target `<id>-iframe[-env].twenty20solutions.com`. Unknown hosts keep the
 * historical `host.replace('app', 'iframe')` fallback — a no-op when the host
 * doesn't contain "app" (e.g., `localhost`), a substitution otherwise (e.g.,
 * `myapp.example.com` → `myiframe.example.com`). Preserved so local/dev envs
 * don't regress.
 *
 * The returned host is wrapped by an equipment id prefix at the call site (e.g.
 * `${equipment.id}-iframe-stg.twenty20solutions.com`). That final URL must be
 * covered by the SCE whitelist in `WhiteListedDomainsConfig.js`, which today
 * lists `*iframe`, `*iframe-stg`, and `*iframe-dev` patterns. If a new env name
 * (e.g. `app-prod` / `remotevision-prod`) is ever introduced, the SCE whitelist
 * must be extended in lock-step or the iframe will silently fail at load.
 *
 * @param {string} currentHost - usually `window.location.host`
 * @returns {string} the iframe host suffix to append after the equipment id
 */
export default function deriveIframeHost(currentHost) {
  if ((/^app[.-]/).test(currentHost)) {
    return currentHost.replace(/^app/, 'iframe');
  }
  // Anchored to .epicio.com so an unrelated `remotevision-x.example.com` doesn't
  // get rewritten to an iframe.twenty20solutions.com URL.
  // eslint-disable-next-line unicorn/no-unsafe-regex -- bounded charset, no nested quantifier
  const rvMatch = currentHost.match(/^remotevision(-[\da-z]+)?\.epicio\.com$/);
  if (rvMatch) {
    return `iframe${rvMatch[1] || ''}.twenty20solutions.com`;
  }
  return currentHost.replace('app', 'iframe');
}
